<div id="device" class="page-layout emma simple carded fullwidth">
    <div class="header accent">
        @if (pageType == "edit") {
            <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/admin/devices'">
                <mat-icon>arrow_back</mat-icon>
            </button>
        }

        @if (pageType == "new") {
            <h1>{{ "DEVICES.Device" | translate }} - {{ "DEVICES.Create" | translate }}</h1>
        }
        @if (pageType == "edit") {
            <h1>{{ "DEVICES.Device" | translate }} - {{ device.name }}</h1>
        }
    </div>

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT CARD -->
        <div class="content-card">
            <mat-tab-group [backgroundColor]="'header'">
                <mat-tab label="{{ 'DEVICES.BasicInfo' | translate }}">
                    <div class="content">
                        <form name="productForm" [formGroup]="deviceForm" class="company">
                            <div class="section">
                                <h2 class="section__title">
                                    <mat-icon>business</mat-icon>
                                    <div>{{ "DEVICES.DeviceInfo" | translate }}</div>
                                </h2>

                                <!-- Device name field -->
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "DEVICES.Name" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="name"
                                        formControlName="name"
                                        placeholder="{{ 'DEVICES.Name' | translate }}"
                                        required
                                    />
                                </mat-form-field>

                                <!-- Manufacturer & protocol fields -->
                                <div class="row">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.Manufacturer" | translate }}</mat-label>
                                        <mat-select
                                            formControlName="manufacturer"
                                            placeholder="{{ 'DEVICES.Manufacturer' | translate }}"
                                            [(value)]="selectedManufacturer"
                                            required
                                        >
                                            @for (manufacturer of manufacturers; track manufacturer) {
                                                <mat-option [value]="manufacturer"> {{ manufacturer.name }}​ </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- Device model field -->
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.Model" | translate }}</mat-label>
                                        @if (pageType === "new") {
                                            <mat-select formControlName="model" placeholder="{{ 'DEVICES.Model' | translate }}" required>
                                                @for (model of availableModels; track model.model) {
                                                    <mat-option [value]="model.model">
                                                        {{ model.model }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        }
                                        @if (pageType === "edit") {
                                            <input
                                                matInput
                                                name="model"
                                                formControlName="model"
                                                placeholder="{{ 'DEVICES.Model' | translate }}"
                                                required
                                            />
                                        }
                                    </mat-form-field>
                                </div>

                                <!-- Device type field​ -->
                                <div class="row">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "DEVICES.Protocol" | translate }}</mat-label>
                                        <mat-select formControlName="protocol" placeholder="{{ 'DEVICES.Protocol' | translate }}" required>
                                            @for (protocol of selectedManufacturer?.protocols; track protocol) {
                                                <mat-option [value]="protocol">
                                                    {{ protocol?.name }} -
                                                    {{ protocol?.endpoint }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            {{ "DEVICES.DeviceType" | translate }}
                                        </mat-label>
                                        <mat-select
                                            formControlName="deviceType"
                                            placeholder="{{ 'DEVICES.DeviceType' | translate }}"
                                            required
                                        >
                                            @for (type of avaliableDeviceType; track type) {
                                                <mat-option [value]="type">
                                                    {{ type | translate }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- Device serial field -->
                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            {{ "DEVICES.SerialNumber" | translate }}
                                        </mat-label>
                                        <input
                                            matInput
                                            name="serialNumber"
                                            formControlName="serialNumber"
                                            placeholder="{{ 'DEVICES.SerialNumber' | translate }}"
                                            required
                                        />
                                    </mat-form-field>

                                    <!-- Device Data Frequency field -->
                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            {{ "DEVICES.DataFrequency" | translate }}
                                        </mat-label>
                                        <input
                                            matInput
                                            type="number"
                                            name="dataFrequency"
                                            formControlName="dataFrequency"
                                            placeholder="{{ 'DEVICES.DataFrequency' | translate }}"
                                            required
                                        />
                                    </mat-form-field>
                                </div>

                                <!-- SIM/IMEI and device calibration date -->
                                <div class="row">
                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            {{ "DEVICES.SimOrImei" | translate }}
                                        </mat-label>
                                        <input
                                            matInput
                                            type="text"
                                            name="simOrImei"
                                            formControlName="simOrImei"
                                            placeholder="{{ 'DEVICES.SimOrImei' | translate }}"
                                        />
                                    </mat-form-field>

                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            {{ "DEVICES.LastCalibrationDate" | translate }}
                                        </mat-label>
                                        <input
                                            matInput
                                            type="date"
                                            name="lastCalibrationDate"
                                            formControlName="lastCalibrationDate"
                                            placeholder="{{ 'DEVICES.LastCalibrationDate' | translate }}"
                                        />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-action">
                                @if (pageType == "new") {
                                    <button
                                        mat-raised-button
                                        class="button-save"
                                        color="primary"
                                        [disabled]="deviceForm.invalid"
                                        (click)="add()"
                                    >
                                        {{ "DEVICES.ADD" | translate }}
                                    </button>
                                }
                                @if (pageType == "new") {
                                    <button mat-raised-button (click)="cancel()">
                                        {{ "DEVICES.CANCEL" | translate }}
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </mat-tab>
                @if (pageType === "edit") {
                    <mat-tab label="{{ 'DEVICES.Image' | translate }}">
                        <div class="content" fxLayout="column">
                            <h2 class="section__title">
                                <mat-icon>image</mat-icon>
                                <mat-label>{{ "DEVICES.Image" | translate }}</mat-label>
                            </h2>
                            @if (!imageUrl) {
                                <ngx-file-drop dropZoneLabel="{{ 'DEVICES.DropFiles' | translate }}" (onFileDrop)="imageDropped($event)">
                                </ngx-file-drop>
                            }
                            @if (imageUrl && uploadedFile) {
                                <div fxLayout="column" fxLayoutAlign="space-between center">
                                    <img [src]="imageUrl" fxFlexAlign="center" />
                                    <button
                                        mat-raised-button
                                        class="button-remove"
                                        color="primary"
                                        (click)="removeImage()"
                                        fxFlexAlign="center"
                                    >
                                        <mat-icon>delete</mat-icon>
                                        {{ "DEVICES.RemoveImage" | translate }}
                                    </button>
                                </div>
                            }
                            @if (imageUrl && !uploadedFile) {
                                <div fxLayout="column" fxLayoutAlign="space-between center">
                                    @if (imageCloudinaryImage; as deviceImage) {
                                        <advanced-image [cldImg]="deviceImage"></advanced-image>
                                    } @else {
                                        <img [src]="imageUrl" alt="device picture" />
                                    }
                                    <button
                                        mat-raised-button
                                        class="button-remove"
                                        color="primary"
                                        (click)="removeImage()"
                                        fxFlexAlign="center"
                                    >
                                        <mat-icon>delete</mat-icon>
                                        {{ "DEVICES.RemoveImage" | translate }}
                                    </button>
                                </div>
                            }
                        </div>
                    </mat-tab>
                }
                @if (pageType === "edit") {
                    <mat-tab label="{{ 'DEVICES.Files' | translate }}">
                        <div class="content content--files">
                            <div class="files-filters">
                                <div class="files-filters__inputs" [formGroup]="fileFiltersForm">
                                    <mat-form-field>
                                        <mat-select
                                            placeholder="{{ 'DEVICES.FileType' | translate }}"
                                            formControlName="source"
                                            (selectionChange)="handleFileFiltersChange()"
                                        >
                                            <mat-option [value]="null">{{ "DEVICES.AllFileTypes" | translate }}</mat-option>
                                            <mat-option value="svantek_csv">{{ "DEVICES.CsvFiles" | translate }}</mat-option>
                                            <mat-option value="svantek_svl">{{ "DEVICES.SvlFiles" | translate }}</mat-option>
                                            <mat-option value="nti_xl3_file">{{ "DEVICES.Xl3Files" | translate }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="files-filters__range">
                                        <mat-date-range-input [rangePicker]="fileDateRangePicker">
                                            <input
                                                matStartDate
                                                formControlName="startDate"
                                                placeholder="{{ 'DEVICES.FileStartDate' | translate }}"
                                                (dateChange)="handleFileFiltersChange()"
                                            />
                                            <input
                                                matEndDate
                                                formControlName="endDate"
                                                placeholder="{{ 'DEVICES.FileEndDate' | translate }}"
                                                (dateChange)="handleFileFiltersChange()"
                                            />
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matSuffix [for]="fileDateRangePicker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #fileDateRangePicker></mat-date-range-picker>
                                    </mat-form-field>
                                </div>

                                <div class="files-filters__actions">
                                    <button
                                        mat-stroked-button
                                        type="button"
                                        [disabled]="!hasActiveFileFilters"
                                        (click)="clearFileFilters()"
                                    >
                                        {{ "DEVICES.ClearFileFilters" | translate }}
                                    </button>
                                    <div class="files-filters__selection">
                                        {{ "DEVICES.SelectedFilesCount" | translate: { count: selectedFilesCount } }}
                                    </div>

                                    <button
                                        mat-raised-button
                                        color="primary"
                                        [disabled]="selectedFilesCount === 0"
                                        (click)="downloadSelectedFiles()"
                                    >
                                        {{ "DEVICES.DownloadSelectedFiles" | translate }}
                                    </button>
                                </div>
                            </div>

                            @if (isFileDateRangeInvalid) {
                                <div class="files-validation-error">
                                    {{ "DEVICES.FileDateRangeError" | translate }}
                                </div>
                            } @else if (files.length) {
                                <div class="files-table-scroll">
                                    <mat-table [dataSource]="files" class="device-files-table">
                                        <ng-container matColumnDef="select">
                                            <mat-header-cell *matHeaderCellDef class="mat-column-select">
                                                <mat-checkbox
                                                    [checked]="areAllFilesOnPageSelected()"
                                                    [indeterminate]="hasSomeFilesOnPageSelected()"
                                                    [matTooltip]="'DEVICES.SelectCurrentPageFiles' | translate"
                                                    [attr.aria-label]="'DEVICES.SelectCurrentPageFiles' | translate"
                                                    (change)="toggleCurrentPageSelection($event.checked)"
                                                >
                                                </mat-checkbox>
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let file" class="mat-column-select">
                                                <mat-checkbox
                                                    [checked]="isFileSelected(file.id)"
                                                    [attr.aria-label]="'DEVICES.SelectFile' | translate: { name: file.originalName }"
                                                    (click)="$event.stopPropagation()"
                                                    (change)="toggleFileSelection(file.id, $event.checked)"
                                                >
                                                </mat-checkbox>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="name">
                                            <mat-header-cell *matHeaderCellDef>
                                                {{ "DEVICES.FileName" | translate }}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let file">
                                                {{ file.originalName }}
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="creationDate">
                                            <mat-header-cell *matHeaderCellDef>
                                                {{ "DEVICES.FileCreationDate" | translate }}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let file">
                                                {{ file.originalDate | date: "medium" }}
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="size">
                                            <mat-header-cell *matHeaderCellDef>
                                                {{ "DEVICES.FileSize" | translate }}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let file">
                                                {{ formatFileSize(file.size) }}
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="uploadDate">
                                            <mat-header-cell *matHeaderCellDef>
                                                {{ "DEVICES.FileUploadDate" | translate }}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let file">
                                                {{ file.uploadDate | date: "medium" }}
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="actions">
                                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                            <mat-cell *matCellDef="let file">
                                                <button
                                                    mat-icon-button
                                                    color="primary"
                                                    [matTooltip]="'DEVICES.DownloadFile' | translate"
                                                    [attr.aria-label]="'DEVICES.DownloadFile' | translate"
                                                    (click)="downloadFile(file)"
                                                >
                                                    <mat-icon>cloud_download</mat-icon>
                                                </button>
                                                <button
                                                    mat-icon-button
                                                    color="primary"
                                                    [disabled]="!canReprocessFile(file)"
                                                    [matTooltip]="'DEVICES.ReprocessFile' | translate"
                                                    [attr.aria-label]="'DEVICES.ReprocessFile' | translate"
                                                    (click)="reprocessFile(file)"
                                                >
                                                    <mat-icon>refresh</mat-icon>
                                                </button>
                                            </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="fileDisplayedColumns"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: fileDisplayedColumns"></mat-row>
                                    </mat-table>
                                </div>
                            } @else {
                                <div class="files-empty-state">
                                    <img class="files-empty-state__image" src="assets/illustrations/empty-files.svg" alt="" />
                                    <div class="files-empty-state__text">
                                        {{ (hasActiveFileFilters ? "DEVICES.NoFilesMatchFilters" : "DEVICES.NoFiles") | translate }}
                                    </div>
                                </div>
                            }
                            <div class="files-footer">
                                <button
                                    mat-icon-button
                                    class="files-footer__rescan"
                                    type="button"
                                    [disabled]="rescanningFileStorage"
                                    [matTooltip]="'DEVICES.RescanFileStorage' | translate"
                                    [attr.aria-label]="'DEVICES.RescanFileStorage' | translate"
                                    (click)="rescanFileStorage()"
                                >
                                    <mat-icon>sync</mat-icon>
                                </button>
                                @if (files.length) {
                                    <mat-paginator
                                        [length]="filesTotal"
                                        [pageIndex]="filesPageIndex"
                                        [pageSize]="filesPageSize"
                                        [pageSizeOptions]="[25, 50, 100]"
                                        (page)="handleFilesPage($event)"
                                    >
                                    </mat-paginator>
                                }
                            </div>
                        </div>
                    </mat-tab>
                }
            </mat-tab-group>
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
